/*
 * Title: Auth/Signin.tsx
 * Author: Chris Rosa
 * Email: chris@encore.fans
 * Description: import Auth component form containers.
 * Date: 30 Jun 2022
 * Copyright (c) Encore, 2022
 * Version:0.1.0
 */

import * as React from "react";
import Signin from "@containers/fans/Signin";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { useAuth0 } from "@auth0/auth0-react";


type Props = {
  type: string;
};

const SigninPage: React.FC<Props> = (props) => {
  const rnavigate = useNavigate();
  const location = useLocation();
  const token = useSelector((state: any) => state.user?.token);
  const { loginWithRedirect, isAuthenticated, user } = useAuth0();


  return (
    <div>
      {token && <Navigate to="/my-rewards" />}

      <Signin location={location.pathname} navigate={rnavigate} loginWithRedirect={loginWithRedirect} />

    </div>
  );
};

export default SigninPage;

